var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", { attrs: { errors: _vm.sowPigGetErrors } }),
      _c("v-data-table", {
        attrs: {
          items: _vm.sowPigList,
          headers: _vm.headers,
          dense: "",
          "single-expand": "",
          loading: _vm.sowPigGetting
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item, expand, isExpanded }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.sow_number))]),
                  _c("td", [_vm._v(_vm._s(item.status))]),
                  _c("td", [
                    _vm._v(_vm._s(item.status_last_updated.dateFormat()))
                  ]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          class: isExpanded ? "is-expanded" : "",
                          attrs: { color: "blue-grey", text: "", small: "" },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-chevron-down")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c(
                  "td",
                  { attrs: { colspan: "4" } },
                  [
                    _c(
                      "v-container",
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "text-center",
                                attrs: { cols: "3" }
                              },
                              [
                                _c("span", { staticClass: "blue-grey--text" }, [
                                  _vm._v("Service")
                                ])
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "text-center",
                                attrs: { cols: "3" }
                              },
                              [
                                _c("span", { staticClass: "blue-grey--text" }, [
                                  _vm._v("Forrowing")
                                ])
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "text-center",
                                attrs: { cols: "3" }
                              },
                              [
                                _c("span", { staticClass: "blue-grey--text" }, [
                                  _vm._v("Weaning")
                                ])
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "text-center",
                                attrs: { cols: "3" }
                              },
                              [
                                _c("span", { staticClass: "blue-grey--text" }, [
                                  _vm._v("Piglets")
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _c("v-divider"),
                        _vm._l(item.sow_pig_records, function(item, index) {
                          return _c(
                            "v-row",
                            { key: index, staticClass: "pa-0" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center pb-0",
                                  attrs: { cols: "3" }
                                },
                                [
                                  _c(
                                    "small",
                                    { staticClass: "blue-grey--text" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          (item.service || "").dateFormat()
                                        )
                                      )
                                    ]
                                  ),
                                  _c("v-divider")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center pb-0",
                                  attrs: { cols: "3" }
                                },
                                [
                                  _c(
                                    "small",
                                    { staticClass: "blue-grey--text" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          (item.forrowing || "").dateFormat()
                                        )
                                      )
                                    ]
                                  ),
                                  _c("v-divider")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center pb-0",
                                  attrs: { cols: "3" }
                                },
                                [
                                  _c(
                                    "small",
                                    { staticClass: "blue-grey--text" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          (item.weaning || "").dateFormat()
                                        )
                                      )
                                    ]
                                  ),
                                  _c("v-divider")
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-right pb-0",
                                  attrs: { cols: "3" }
                                },
                                [
                                  _c(
                                    "small",
                                    { staticClass: "blue-grey--text" },
                                    [_vm._v(_vm._s(item.piglets || "N/A"))]
                                  ),
                                  _c("v-divider")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }